import React from 'react'
import Intro from './component/about component/intro'
import Footer from './component/footer'
import Navbar from './component/Navbar'

function About() {
  return (<>
    <Navbar/>
     <Intro/>
    <Footer/>
  </>
  
  )
}

export default About